import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { SpinnerDotted } from '.';
import { exclametaryYellowInfoIcon, NoSlot } from '../../../assets/images';
import { handleAppError } from '../../handlers';
import EmptyListCard from './EmptyListCard';

const Slots = ({
  provider, employeeID, packageID, slotHandler, benefitType, address = {}
}) => {

  const [state, setState] = useState({
    loading: false, provider: provider, employeeID: employeeID, packageID: packageID, showDates: false, dates: Object.keys(provider.provider_slots),
    benefitType: benefitType, addresses: [], selectedDate: Object.keys(provider.provider_slots)[0], slots: [], selectedSlot: null
  });

  const setSubState = (newState) => {
    setState(prevState => { return { ...prevState, ...newState } })
  }

  useEffect(() => {
    if(state.selectedDate){
      setSubState({ loading: true })
      fetchSlots(state.selectedDate)
    }
  }, [])

  const fetchSlots = (date) => {
    let ids = []
    ids.push(state.packageID)
    setSubState({ loading: true })
    const params = {
      benefit_type: state.benefitType,
      booking_date: date,
      package_ids: ids,
      provider_id: state.provider.provider_id,
      company_id: sessionStorage.getItem('company_id'),
      additional_info: {
        co_ordinates: { latitude: address.latitude, longitude: address.longitude},
        pincode: address.zip_code
      }
    }

    if (state.employeeID != null) {
      let url = window.API_URL + "corporate/customers/" + state.employeeID + "/benefits/appointments/slots"
      window.axios.post(url, params)
        .then(function (response) {
          const slots = response.data.booking_slots[0].slots
          setSubState({ slots: slots, loading: false })
        })
        .catch(function (error) {
          handleAppError(error)
          setSubState({ loading: false })
        })
    }
  }

  const getDay = (date) => {
    if (!date || typeof date !== 'string') {
      return '';
    }

    let slot = date.split("-")
    let newDate = new Date(slot[0], slot[1] - 1, slot[2])
    let dayName = getDateName(newDate.getDay())
    return dayName
  }

  const getDate = (date) => {
    let slot = date.split("-")
    let newDate = new Date(slot[0], slot[1] - 1, slot[2])
    let number = newDate.getDate()
    if (number < 10) {
      number = "0" + String(number)
    }
    return number
  }

  const getDateName = (weekday) => {
    let name = ""
    if (weekday === 0) {
      name = 'Sun'
    } else if (weekday === 1) {
      name = 'Mon'
    } else if (weekday === 2) {
      name = 'Tue'
    } else if (weekday === 3) {
      name = 'Wed'
    } else if (weekday === 4) {
      name = 'Thu'
    } else if (weekday === 5) {
      name = 'Fri'
    } else if (weekday === 6) {
      name = 'Sat'
    }
    return name
  }

  const getMonthYear = (date) => {
    const monthYear = moment(date).format("MMM YYYY")
    return monthYear.toLocaleUpperCase();
  }

  const convertTimeFormat = (time) => {
    const [hours, minutes] = time.split(':');
    let formattedHours = parseInt(hours);
    let period = 'AM';
    if (formattedHours > 12) {
      formattedHours -= 12;
      period = 'PM';
    } else if (formattedHours === 12) {
      period = 'PM';
    } else if (formattedHours === 0) {
      formattedHours = 12;
    }
    const formattedTime = `${formattedHours.toString().padStart(2, '0')}:${minutes} ${period}`;
    return formattedTime;
  };

  const changeDate = (value) => {
    setSubState({ selectedDate: value })
    fetchSlots(value);
  }

  const changeTime = (value) => {
    setSubState({ selectedSlot: value })
    if (state.selectedDate != null && value != null) {
      slotHandler(state.selectedDate, value, state.provider.provider_id, state.provider)
    }
  }

  const renderInfo = () => {
    return (
      <div className='border rounded-md flex flex-start w-full p-2 mt-3 items-center' style={{ backgroundColor: '#FDF1E4', borderColor: '#FBCE7A' }}>
        <img src={exclametaryYellowInfoIcon} className={'h-4 mr-2'} />
        <div className='text-gray-700 text-sm font-bold'>
          Checkups usually take 2hrs longer on saturdays
        </div>

      </div>
    )
  }

  const renderSlots = () =>{
    return (
        state.slots.map((item, index) => {
          return (
            <div className={`rounded-xl border border-gray-200 mr-2 mt-2 cursor-pointer  ${state.selectedSlot === item.utc_slot_time ? 'bg-blue-400' : 'bg-gray-100 hover:border-blue-400'}`} onClick={() => changeTime(item.utc_slot_time)}>
              <div className='w-20 border-box flex flex-col justify-center items-center p-1 align-middle'>
                <div className={`text-sm font-bold ${state.selectedSlot === item.utc_slot_time ? 'bg-blue-400 text-white' : 'bg-gray-100 text-gray-600'} `}>{convertTimeFormat(item.start_time)}</div>
              </div>
            </div>
          )
        }
      )
    )
  }

  const renderEmptySlotCard = () => {
    let ahcSubTitleText = 'Currently there are no slots available for the selected date for this package'
    let preEmpSubTitleText = 'Currently there are no slots available for the selected date'
    return <EmptyListCard
              svgsrc={NoSlot}
              classes='mt-4'
              title='All slots booked'
              subTitleClasses='w-72'
              subTitle={state.benefitType == 'ahc' ? ahcSubTitleText : preEmpSubTitleText}
    />
  }

  return (
    <div className='mt-4'>
      <div className='flex justify-between'>
        <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500'>
          SELECT SLOT
        </div>
        <div className='text-xs font-semibold tracking-widest leading-3 text-gray-500'>
          {getMonthYear(state.selectedDate)}
        </div>
      </div>
      <div className='flex w-full overflow-auto scroll-smooth no-scrollbar'>
        {state.dates?.length > 0 && state.dates.map((item, index) => {
          return (
            <div className={`rounded-md border border-gray-200 mr-3 mt-3 cursor-pointer ${state.selectedDate === item ? 'bg-blue-400' : 'bg-gray-100 hover:border-blue-400'}`} onClick={() => changeDate(item)}>
              <div className='w-14 border-box flex flex-col justify-center items-center py-1'>
                <div className={`text-sm font-bold ${state.selectedDate === item ? 'bg-blue-400 text-white' : 'bg-gray-100 text-gray-300'} `}>{getDay(item)}</div>
                <div className={`text-base font-bold ${state.selectedDate === item ? 'bg-blue-400 text-white' : 'bg-gray-100 text-gray-600'} `}>{getDate(item)}</div>
              </div>
            </div>
          )
        })}
      </div>
      {state.selectedDate && getDay(state.selectedDate) == 'Sat' && renderInfo()}
      { state.loading ? 
        <div className='flex justify-center items-center mt-4'>
          <SpinnerDotted classes='m-auto' />
        </div> :
      <div className='flex mt-3 flex-wrap w-full justify-start' style={{ flexWrap: 'wrap' }}>
         { (state.slots.length) > 0 ? renderSlots() : renderEmptySlotCard()}
      </div>}
    </div>
  );
};

export default Slots;